import { render, staticRenderFns } from "./postureEventData.vue?vue&type=template&id=150b4f17&"
import script from "./postureEventData.vue?vue&type=script&lang=js&"
export * from "./postureEventData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150b4f17')) {
      api.createRecord('150b4f17', component.options)
    } else {
      api.reload('150b4f17', component.options)
    }
    module.hot.accept("./postureEventData.vue?vue&type=template&id=150b4f17&", function () {
      api.rerender('150b4f17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data/postureEventData.vue"
export default component.exports